import { TKanbanCardProperty } from '../../../../../../../../types/types';

export const getToggledProperties = (
    properties: TKanbanCardProperty[],
    property: TKanbanCardProperty,
) => {
    if (properties.includes(property)) {
        properties = properties.filter(item => item !== property);
    } else {
        properties = [...properties, property];
    }
    return properties;
}
